import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Switch } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(() => ({
  header: {
    textAlign: 'center',
  },
}));

const inputProps = { 'aria-label': 'secondary checkbox' };

export default function Header(props) {
  const classes = useStyles();
  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
  const handleChange = (event) => props.switch(event.target.checked);

  return (
    <div className={classes.header}>
      <Switch
        checked={props.status}
        onChange={handleChange}
        inputProps={inputProps}
        color="primary"
      />
    </div>
  );
}

Header.propTypes = {
  switch: PropTypes.func,
  status: PropTypes.bool,
};
